<template>
  <div class="photos-empty">
    <div class="photos-empty__image"></div>
    <div class="photos-empty__text">
      <div v-if="message">{{ message }}</div>
      <div>{{ mainText }}</div>
    </div>
    <ui-button
      v-if="showButton"
      :to="{ name: 'photos-add' }"
      color="primary"
      icon="icon-plus"
    >
      {{ $t("message.photos.list.addNew") }}
    </ui-button>
  </div>
</template>

<script>
export default {
  name: "PhotosEmpty",
  props: {
    message: {
      type: String,
      default: ""
    },
    mainText: {
      type: String,
      default: function() {
        return this.$t("message.photos.list.empty");
      }
    },
    showButton: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.photos-empty {
  margin: $spacing * 8 0 $spacing * 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__image {
    background: url("~@/static/photos/empty.svg") no-repeat center;
    width: 436px;
    height: 268px;
    margin-bottom: $spacing * 6;
  }

  &__text {
    @include font-size(22px);
    line-height: 28px;
    font-weight: 600;
    letter-spacing: -0.02em;
    margin-bottom: $spacing * 6;
    color: $dark-blue-3;
    text-align: center;
  }
}
</style>
